<template></template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";

export default {
  name: "swal-admin",
  mixins: [mixins],
  components: {},
  mounted() {
    db.on("swalAdmin", this.show);
  },
  destroyed() {
    db.off("swalAdmin", this.show);
  },
  computed: {},
  methods: {
    show(testo) {
      // se nn esiste, impostalo
      if (!this.isAdminSet) {
        db.emit("promptChangeAdmin");
        return;
      }

      Swal.fire({
        icon: "error",
        title: "Attenzione",
        text: testo
          ? testo
          : "Azione permessa solo all'amministratore d'asta (" +
            this.adminUsername +
            ")",
        confirmButtonText: "Ok, ho capito",
      });
    },
  },
};
</script>
<style></style>
